import { render, staticRenderFns } from "./RankMorePopup.vue?vue&type=template&id=5288ad41&scoped=true"
import script from "./RankMorePopup.vue?vue&type=script&lang=js"
export * from "./RankMorePopup.vue?vue&type=script&lang=js"
import style0 from "./RankMorePopup.vue?vue&type=style&index=0&id=5288ad41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288ad41",
  null
  
)

export default component.exports